import { render, staticRenderFns } from "./AssignmentQuestion.vue?vue&type=template&id=4c22872b&"
import script from "./AssignmentQuestion.vue?vue&type=script&lang=js&"
export * from "./AssignmentQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports